import request from "../../utils/request";

const API_ROUTE = `${process.env.REACT_APP_BASE_API}api/v1`;

export async function auth(body) {
    return request(`${API_ROUTE}/auth`, {
        method: "POST",
        data: body,
    });
}
